
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33824',
  depVersions: {
  "documents-public-ui": "static-1.33824",
  "client-types": "static-1.443",
  "documents-lib": "static-1.33829",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1853",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.98",
  "hs-promise-utils": "static-1.5322",
  "hs-test-utils": "static-1.7718",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1786",
  "HubStyleTokens": "static-2.11153",
  "I18n": "static-7.1553",
  "jasmine-immutable": "static-1.2750",
  "jasmine-runner": "static-1.6187",
  "lodash": "static-1.3",
  "quartz": "static-1.6624",
  "react": "static-7.176",
  "react-dlb": "static-1.70",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16364",
  "reporting-data": "static-1.66259",
  "reporting-testing-lib": "static-1.8192",
  "reporting-visualizations": "static-1.58335",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4476",
  "webpack-env": "static-1.54",
  "atom": "static-1.4802",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2198",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90919",
  "cssUtils": "static-1.712",
  "customer-data-filters-ui": "static-1.38655",
  "customer-data-objects": "static-1.7351",
  "customer-data-property-utils": "static-1.7803",
  "data-fetching-client": "static-1.9408",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4263",
  "flux-actions": "static-1.302",
  "FormsCommonComponents": "static-1.85128",
  "FormUrlGenerator": "static-2.4462",
  "foundations-components": "static-1.7379",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3873",
  "HubStyle": "static-2.11461",
  "icons": "static-2.618",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6875",
  "metrics-js": "static-1.9346",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3591",
  "property-translator": "static-1.5145",
  "quartz-config": "static-1.402",
  "quartz-core": "static-1.5843",
  "quick-fetch": "static-1.3667",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5112",
  "react-virtualized": "static-2.93",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7891",
  "reference-resolvers-lite": "static-1.7822",
  "report-customization-components": "static-1.12313",
  "reporting-enablement": "static-1.21868",
  "reporting-reports": "static-1.65937",
  "reporting-snowflake": "static-1.54877",
  "reporting-ui-components": "static-2.63531",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4339",
  "sales-content-partitioning": "static-1.8666",
  "SalesContentIndexUI": "static-3.8797",
  "sanitize": "static-1.4206",
  "sanitize-text": "static-1.7871",
  "self-service-api": "static-1.9961",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1468",
  "signup-constants": "static-1.18263",
  "signup-ui-lego-core": "static-1.20273",
  "signup-ui-url-generator": "static-2.7767",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.482",
  "superstore": "static-1.4503",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10726",
  "ui-addon-i18n": "static-1.10861",
  "ui-addon-react-router-dom": "static-1.9278",
  "ui-addon-upgrades": "static-9.17499",
  "ui-asset-management-lib": "static-1.10613",
  "ui-images": "static-2.1073",
  "UIComponents": "static-3.8100",
  "usage-tracker": "static-1.7065",
  "usage-tracker-container": "static-1.7055",
  "usage-tracker-core": "static-1.6915",
  "usage-tracker-public": "static-1.6876",
  "viral-links-lib": "static-1.6755",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3165",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2901",
  "quartz-webpack": "static-1.2848",
  "ai-components-ui-library": "static-1.8184",
  "amplitude-session-replay-browser": "static-1.54",
  "foundations-assets": "static-1.4563",
  "foundations-theming": "static-1.4137",
  "quartz-auth": "static-1.299",
  "usage-tracker-session-replay": "static-1.4751",
  "foundations-theming-base": "static-1.3122",
  "HeadJS": "static-2.699",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2829",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4062",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7657",
  "graphql": "static-1.76",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3418",
  "reporting-client-types": "static-1.2359",
  "hs-story-utils": "static-1.9158",
  "react-flip-move": "static-1.64",
  "hub-http-shared-msw-handlers": "static-1.9303",
  "hubspotter-http": "static-1.4416",
  "sassPrefix": "static-1.150",
  "conversations-skeleton-state": "static-1.6980",
  "crm-message-bus": "static-1.42165",
  "customer-data-filters-ui-msw-helpers": "static-1.21089",
  "customer-data-objects-ui-components": "static-1.12734",
  "customer-data-reference-ui-components": "static-1.12871",
  "customer-data-ui-utilities": "static-1.9556",
  "framework-builder-read-service-client": "static-1.3785",
  "framework-data-schema-quick-fetch": "static-1.6505",
  "framework-data-schema-resolvers": "static-1.6600",
  "inbound-db-properties-service-client": "static-1.3616",
  "multi-account-reference-resolvers": "static-1.700",
  "onboarding-tours": "static-1.16173",
  "reporting-datasets-permissions-lib": "static-1.12868",
  "ui-addon-teams": "static-1.21140",
  "apollo-stack-hubspot": "static-3.80",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67440",
  "customer-data-properties": "static-1.50583",
  "forms-ai-lib": "static-1.3895",
  "forms-utils-lib": "static-1.12051",
  "foundations-components-test-utils": "static-1.4862",
  "react-dnd-compat": "static-1.4355",
  "react-tinymce": "static-1.54455",
  "tinymce-config": "static-2.53581",
  "ui-gdpr-components": "static-1.10077",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3648",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.1019",
  "ui-fonts": "static-1.415",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.781",
  "mobile-manifest-mixins": "static-1.472",
  "quartz-head": "static-1.289",
  "quartz-i18n": "static-1.299",
  "quartz-routing": "static-1.54",
  "quartz-test": "static-1.299",
  "batch-promise": "static-1.1261",
  "external-options-client-types": "static-1.3921",
  "react-colorpicker": "static-2.9943",
  "copilot-toolkit": "static-1.10370",
  "data-quality-ui-library": "static-1.12173",
  "html-to-image": "static-1.48",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40464",
  "reporting-insights-lib": "static-1.981",
  "reporting-plugins": "static-1.9900",
  "ui-addon-draggable-compat": "static-2.3985",
  "ui-addon-opt": "static-4.8119",
  "ui-shepherd-react": "static-3.9875",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24547",
  "hubspot-apollo-client": "static-1.4611",
  "sales-templates-service-types-lib": "static-1.3931",
  "ui-business-units-lib": "static-1.8753",
  "merchandise-lib": "static-1.256",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5371",
  "salesImages": "static-1.519",
  "ts-schema": "static-1.3842",
  "upgrade-management-service-types": "static-1.4239",
  "timezone-utils": "static-2.4975",
  "bender-build-tools": "static-1.2867",
  "chatspot-core": "static-1.20083",
  "chirp-fetch": "static-1.1613",
  "bend-plugin-foundations-theming": "static-1.2620",
  "stylex": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.9301",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3561",
  "crm-pipelines-api-client-types": "static-1.3902",
  "multi-currency-client-types": "static-1.3456",
  "getting-started-shared-tasks": "static-1.17707",
  "growth-data-modal": "static-1.5065",
  "growth-onboarding-confetti": "static-1.2783",
  "growth-onboarding-next-action-utils": "static-1.1226",
  "navigation-components": "static-1.17074",
  "onboarding-tours-client": "static-1.4387",
  "onboarding-tours-utils": "static-1.239",
  "ui-shepherd-tracker": "static-1.7256",
  "ui-universal-auth": "static-1.8607",
  "user-context": "static-1.4826",
  "cms-field-types": "static-1.4538",
  "content-icons-ui": "static-1.2132",
  "integrations-lib": "static-1.15212",
  "calling-global-api": "static-1.63462",
  "calling-internal-common": "static-1.31023",
  "calling-lifecycle-internal": "static-1.64844",
  "calling-lifecycle-messages": "static-1.57138",
  "commerce-products-lib": "static-1.8663",
  "crm-links": "static-1.5983",
  "file-manager-components": "static-1.22704",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.398",
  "inbounddb-objects-service-types": "static-1.3988",
  "meetings-icalendar-utils-lib": "static-1.365",
  "object-builder-ui-client": "static-1.47769",
  "pipeline-validation-client-types": "static-1.3725",
  "property-value-citations": "static-1.1197",
  "pulse": "static-1.230",
  "smart-property-lib": "static-1.5667",
  "tiered-pricing": "static-1.726",
  "ui-addon-iframeable": "static-1.8752",
  "final-form": "static-1.64",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19348",
  "tinymce-themes": "static-1.55551",
  "data-token-picker": "static-1.15945",
  "hub-http-contrib": "static-1.2776",
  "interframe": "static-3.4523",
  "tinymce-data": "static-1.39666",
  "tinymce-plugins": "static-1.56695",
  "ui-addon-sales-email": "static-1.4944",
  "magpie-lib": "static-1.5307",
  "magpie-types": "static-1.4767",
  "simple-logging-lib": "static-1.2782",
  "content-assistance-lib": "static-1.7356",
  "dashboard-lib": "static-1.80369",
  "ExportDialog": "static-6.10118",
  "hubspot-prosemirror": "static-1.17431",
  "hubspot-prosemirror-plugins": "static-1.17423",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8421",
  "campaign-roi-lib": "static-1.8098",
  "feedback-loader": "static-1.28738",
  "onboarding-scopes": "static-1.6175",
  "apollo-link-hub-http": "static-2.4380",
  "hubspot-apollo-cache": "static-1.70",
  "growth-monetization-service-types": "static-1.4255",
  "nav-client-types": "static-1.2063",
  "purchase-motions-api": "static-1.5374",
  "trials-service-types": "static-1.3656",
  "chatspot-client-types": "static-1.10395",
  "idb-keyval": "static-1.38",
  "reactive-lib": "static-1.457",
  "getting-started-shared-tasks-store": "static-1.16825",
  "integrations-error-boundary-lib": "static-1.12627",
  "integrations-tracking-lib": "static-1.5315",
  "native-integrations-shared-strings": "static-1.7520",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10104",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31029",
  "shared-worker-versioning": "static-1.10748",
  "calling-usage-tracker": "static-1.6270",
  "voice-sms-access-library": "static-1.51",
  "customer-data-tracking": "static-1.6593",
  "products-iframe-lib": "static-1.7158",
  "products-ui-components-shared-msw-handlers": "static-1.9685",
  "location-customization-utils-lib": "static-1.8361",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3886",
  "video-components-external": "static-1.10361",
  "video-data-lib": "static-1.34019",
  "directed-graph": "static-1.667",
  "event-emitter": "static-1.657",
  "breeze-intelligence-kit": "static-1.5226",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9386",
  "fsm": "static-1.3463",
  "policy-lib": "static-1.6531",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9449",
  "navigation-messaging": "static-1.6401",
  "FileManagerLib": "static-1.38344",
  "NamespacedHubStyle": "static-2.8835",
  "FileManagerCore": "static-1.38203",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11919",
  "layout-dnd-utils": "static-1.10894",
  "react-codemirror": "static-1.10337",
  "ui-addon-emoji-picker": "static-1.9621",
  "ui-brand-identity-lib": "static-1.13549",
  "ui-addon-video-player": "static-1.8432",
  "ui-coaching-tips": "static-1.27776",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8297",
  "payment-link-components": "static-1.22763",
  "EmailSignatureEditor": "static-1.23824",
  "eligibility-engine-service-types": "static-1.2937",
  "universal-page-editor-lib": "static-1.2728",
  "calling-orchestration-schema": "static-1.34828",
  "sales-views-client-types": "static-1.4025",
  "crm-record-cards-service-types": "static-1.3389",
  "content-media-composition-data-lib": "static-1.11230",
  "content-media-compositions": "static-2.15237",
  "media-bridge-lib": "static-1.18467",
  "trellis-story-utils": "static-1.4253",
  "storybook-react": "static-1.27",
  "audio-components": "static-1.5520",
  "FileManagerImages": "static-1.35855",
  "video-components": "static-1.12364",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4264",
  "video-embed": "static-1.34853",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67515",
  "layout-data-lib": "static-1.9219",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6317",
  "commerce-tours-lib": "static-1.5617",
  "growth-onboarding-reliability": "static-1.4820",
  "sales-checkout-service-client": "static-1.3426",
  "draft-convert": "static-2.31",
  "draft-extend": "static-3.69",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21185",
  "sales-email-signature-service-client": "static-1.3574",
  "hls.js": "static-1.33",
  "social-insights-client-types": "static-1.21159",
  "outpost": "static-1.3941",
  "advanced-menus-core": "static-1.14705",
  "advanced-menus-lib": "static-1.11694",
  "ui-memberships-settings-lib": "static-1.33258",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14704",
  "simple-menus-lib": "static-1.16221"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33824",
  "client-types": "/client-types/static-1.443",
  "documents-lib": "/documents-lib/static-1.33829",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1853",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.98",
  "hs-promise-utils": "/hs-promise-utils/static-1.5322",
  "hs-test-utils": "/hs-test-utils/static-1.7718",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "HubStyleTokens": "/HubStyleTokens/static-2.11153",
  "I18n": "/I18n/static-7.1553",
  "jasmine-immutable": "/jasmine-immutable/static-1.2750",
  "jasmine-runner": "/jasmine-runner/static-1.6187",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6624",
  "react": "/react/static-7.176",
  "react-dlb": "/react-dlb/static-1.70",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16364",
  "reporting-data": "/reporting-data/static-1.66259",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8192",
  "reporting-visualizations": "/reporting-visualizations/static-1.58335",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4476",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4802",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2198",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90919",
  "cssUtils": "/cssUtils/static-1.712",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38655",
  "customer-data-objects": "/customer-data-objects/static-1.7351",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7803",
  "data-fetching-client": "/data-fetching-client/static-1.9408",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4263",
  "flux-actions": "/flux-actions/static-1.302",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85128",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4462",
  "foundations-components": "/foundations-components/static-1.7379",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "HubStyle": "/HubStyle/static-2.11461",
  "icons": "/icons/static-2.618",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6875",
  "metrics-js": "/metrics-js/static-1.9346",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3591",
  "property-translator": "/property-translator/static-1.5145",
  "quartz-config": "/quartz-config/static-1.402",
  "quartz-core": "/quartz-core/static-1.5843",
  "quick-fetch": "/quick-fetch/static-1.3667",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5112",
  "react-virtualized": "/react-virtualized/static-2.93",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7891",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7822",
  "report-customization-components": "/report-customization-components/static-1.12313",
  "reporting-enablement": "/reporting-enablement/static-1.21868",
  "reporting-reports": "/reporting-reports/static-1.65937",
  "reporting-snowflake": "/reporting-snowflake/static-1.54877",
  "reporting-ui-components": "/reporting-ui-components/static-2.63531",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4339",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8666",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8797",
  "sanitize": "/sanitize/static-1.4206",
  "sanitize-text": "/sanitize-text/static-1.7871",
  "self-service-api": "/self-service-api/static-1.9961",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1468",
  "signup-constants": "/signup-constants/static-1.18263",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20273",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7767",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "superstore": "/superstore/static-1.4503",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10726",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10861",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9278",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17499",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10613",
  "ui-images": "/ui-images/static-2.1073",
  "UIComponents": "/UIComponents/static-3.8100",
  "usage-tracker": "/usage-tracker/static-1.7065",
  "usage-tracker-container": "/usage-tracker-container/static-1.7055",
  "usage-tracker-core": "/usage-tracker-core/static-1.6915",
  "usage-tracker-public": "/usage-tracker-public/static-1.6876",
  "viral-links-lib": "/viral-links-lib/static-1.6755",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3165",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2901",
  "quartz-webpack": "/quartz-webpack/static-1.2848",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8184",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4563",
  "foundations-theming": "/foundations-theming/static-1.4137",
  "quartz-auth": "/quartz-auth/static-1.299",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4751",
  "foundations-theming-base": "/foundations-theming-base/static-1.3122",
  "HeadJS": "/HeadJS/static-2.699",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2829",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4062",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7657",
  "graphql": "/graphql/static-1.76",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3418",
  "reporting-client-types": "/reporting-client-types/static-1.2359",
  "hs-story-utils": "/hs-story-utils/static-1.9158",
  "react-flip-move": "/react-flip-move/static-1.64",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9303",
  "hubspotter-http": "/hubspotter-http/static-1.4416",
  "sassPrefix": "/sassPrefix/static-1.150",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6980",
  "crm-message-bus": "/crm-message-bus/static-1.42165",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21089",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12734",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12871",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9556",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3785",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6505",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6600",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3616",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.700",
  "onboarding-tours": "/onboarding-tours/static-1.16173",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12868",
  "ui-addon-teams": "/ui-addon-teams/static-1.21140",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67440",
  "customer-data-properties": "/customer-data-properties/static-1.50583",
  "forms-ai-lib": "/forms-ai-lib/static-1.3895",
  "forms-utils-lib": "/forms-utils-lib/static-1.12051",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4862",
  "react-dnd-compat": "/react-dnd-compat/static-1.4355",
  "react-tinymce": "/react-tinymce/static-1.54455",
  "tinymce-config": "/tinymce-config/static-2.53581",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10077",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3648",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.1019",
  "ui-fonts": "/ui-fonts/static-1.415",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.781",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.472",
  "quartz-head": "/quartz-head/static-1.289",
  "quartz-i18n": "/quartz-i18n/static-1.299",
  "quartz-routing": "/quartz-routing/static-1.54",
  "quartz-test": "/quartz-test/static-1.299",
  "batch-promise": "/batch-promise/static-1.1261",
  "external-options-client-types": "/external-options-client-types/static-1.3921",
  "react-colorpicker": "/react-colorpicker/static-2.9943",
  "copilot-toolkit": "/copilot-toolkit/static-1.10370",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12173",
  "html-to-image": "/html-to-image/static-1.48",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40464",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.981",
  "reporting-plugins": "/reporting-plugins/static-1.9900",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3985",
  "ui-addon-opt": "/ui-addon-opt/static-4.8119",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9875",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24547",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4611",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3931",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8753",
  "merchandise-lib": "/merchandise-lib/static-1.256",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5371",
  "salesImages": "/salesImages/static-1.519",
  "ts-schema": "/ts-schema/static-1.3842",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4239",
  "timezone-utils": "/timezone-utils/static-2.4975",
  "bender-build-tools": "/bender-build-tools/static-1.2867",
  "chatspot-core": "/chatspot-core/static-1.20083",
  "chirp-fetch": "/chirp-fetch/static-1.1613",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2620",
  "stylex": "/stylex/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9301",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3561",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3902",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3456",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17707",
  "growth-data-modal": "/growth-data-modal/static-1.5065",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2783",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1226",
  "navigation-components": "/navigation-components/static-1.17074",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4387",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.239",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7256",
  "ui-universal-auth": "/ui-universal-auth/static-1.8607",
  "user-context": "/user-context/static-1.4826",
  "cms-field-types": "/cms-field-types/static-1.4538",
  "content-icons-ui": "/content-icons-ui/static-1.2132",
  "integrations-lib": "/integrations-lib/static-1.15212",
  "calling-global-api": "/calling-global-api/static-1.63462",
  "calling-internal-common": "/calling-internal-common/static-1.31023",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64844",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57138",
  "commerce-products-lib": "/commerce-products-lib/static-1.8663",
  "crm-links": "/crm-links/static-1.5983",
  "file-manager-components": "/file-manager-components/static-1.22704",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.398",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3988",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.365",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47769",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3725",
  "property-value-citations": "/property-value-citations/static-1.1197",
  "pulse": "/pulse/static-1.230",
  "smart-property-lib": "/smart-property-lib/static-1.5667",
  "tiered-pricing": "/tiered-pricing/static-1.726",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8752",
  "final-form": "/final-form/static-1.64",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19348",
  "tinymce-themes": "/tinymce-themes/static-1.55551",
  "data-token-picker": "/data-token-picker/static-1.15945",
  "hub-http-contrib": "/hub-http-contrib/static-1.2776",
  "interframe": "/interframe/static-3.4523",
  "tinymce-data": "/tinymce-data/static-1.39666",
  "tinymce-plugins": "/tinymce-plugins/static-1.56695",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4944",
  "magpie-lib": "/magpie-lib/static-1.5307",
  "magpie-types": "/magpie-types/static-1.4767",
  "simple-logging-lib": "/simple-logging-lib/static-1.2782",
  "content-assistance-lib": "/content-assistance-lib/static-1.7356",
  "dashboard-lib": "/dashboard-lib/static-1.80369",
  "ExportDialog": "/ExportDialog/static-6.10118",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17431",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17423",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8421",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8098",
  "feedback-loader": "/feedback-loader/static-1.28738",
  "onboarding-scopes": "/onboarding-scopes/static-1.6175",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4380",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.70",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4255",
  "nav-client-types": "/nav-client-types/static-1.2063",
  "purchase-motions-api": "/purchase-motions-api/static-1.5374",
  "trials-service-types": "/trials-service-types/static-1.3656",
  "chatspot-client-types": "/chatspot-client-types/static-1.10395",
  "idb-keyval": "/idb-keyval/static-1.38",
  "reactive-lib": "/reactive-lib/static-1.457",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16825",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12627",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5315",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7520",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10104",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31029",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10748",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6270",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.51",
  "customer-data-tracking": "/customer-data-tracking/static-1.6593",
  "products-iframe-lib": "/products-iframe-lib/static-1.7158",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9685",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8361",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3886",
  "video-components-external": "/video-components-external/static-1.10361",
  "video-data-lib": "/video-data-lib/static-1.34019",
  "directed-graph": "/directed-graph/static-1.667",
  "event-emitter": "/event-emitter/static-1.657",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5226",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9386",
  "fsm": "/fsm/static-1.3463",
  "policy-lib": "/policy-lib/static-1.6531",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9449",
  "navigation-messaging": "/navigation-messaging/static-1.6401",
  "FileManagerLib": "/FileManagerLib/static-1.38344",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8835",
  "FileManagerCore": "/FileManagerCore/static-1.38203",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11919",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10894",
  "react-codemirror": "/react-codemirror/static-1.10337",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9621",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13549",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8432",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27776",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8297",
  "payment-link-components": "/payment-link-components/static-1.22763",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23824",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2937",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2728",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34828",
  "sales-views-client-types": "/sales-views-client-types/static-1.4025",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3389",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11230",
  "content-media-compositions": "/content-media-compositions/static-2.15237",
  "media-bridge-lib": "/media-bridge-lib/static-1.18467",
  "trellis-story-utils": "/trellis-story-utils/static-1.4253",
  "storybook-react": "/storybook-react/static-1.27",
  "audio-components": "/audio-components/static-1.5520",
  "FileManagerImages": "/FileManagerImages/static-1.35855",
  "video-components": "/video-components/static-1.12364",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4264",
  "video-embed": "/video-embed/static-1.34853",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67515",
  "layout-data-lib": "/layout-data-lib/static-1.9219",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6317",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5617",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4820",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3426",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-3.69",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21185",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3574",
  "hls.js": "/hls.js/static-1.33",
  "social-insights-client-types": "/social-insights-client-types/static-1.21159",
  "outpost": "/outpost/static-1.3941",
  "advanced-menus-core": "/advanced-menus-core/static-1.14705",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11694",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33258",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14704",
  "simple-menus-lib": "/simple-menus-lib/static-1.16221"
}
};
